import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { MessageData } from '@dataTypes/message.types'
import {
  fetchCallerData,
  resetCallerData,
  updateCallerData,
  updateCallerType,
} from '@store/actions/caller.action'
import { ICallDirection } from '@dataTypes/calls.type'

type CallerState = {
  data: Partial<MessageData> | null
  type: ICallDirection
  error: string | null
  loading: boolean
}

const initialState: CallerState = {
  data: null,
  type: ICallDirection.Incoming,
  loading: false,
  error: null,
}

const callerSlice = createSlice({
  name: 'caller',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchCallerData.fulfilled,
        (state, action: PayloadAction<Partial<MessageData>>) => {
          state.data = action.payload
          state.loading = false
        },
      )
      .addCase(fetchCallerData.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchCallerData.rejected, (state) => {
        state.error = 'Failed to fetch caller data'
        state.loading = false
      })

    builder
      .addCase(
        updateCallerData.fulfilled,
        (state, action: PayloadAction<Partial<MessageData>>) => {
          state.data = action.payload
          state.loading = false
        },
      )
      .addCase(updateCallerData.pending, (state) => {
        state.loading = true
      })
      .addCase(updateCallerData.rejected, (state) => {
        state.error = 'Failed to update caller data'
        state.loading = false
      })

    builder
      .addCase(
        updateCallerType.fulfilled,
        (state, action: PayloadAction<ICallDirection>) => {
          state.type = action.payload
          state.loading = false
        },
      )
      .addCase(updateCallerType.pending, (state) => {
        state.loading = true
      })
      .addCase(updateCallerType.rejected, (state) => {
        state.error = 'Failed to update caller data'
        state.loading = false
      })

    builder
      .addCase(resetCallerData.fulfilled, (state) => {
        state.data = null
        state.loading = false
      })
      .addCase(resetCallerData.pending, (state) => {
        state.loading = true
      })
      .addCase(resetCallerData.rejected, (state) => {
        state.error = 'Failed to update caller data'
        state.loading = false
      })
  },
})

export default callerSlice.reducer
